export default __webpack_public_path__ + "static/media/logo.38833a6f.png";